import { type PodcastAudioSource, toAudioSource } from "@/core/audioSource";
import type { ListeningStore } from "@/stores/ListeningStore";
import type { PlayerStore } from "@/stores/PlayerStore";

/**
 * Bring back the episode the signed-in listener was in the middle of, paused at their position.
 * Does nothing when something is already loaded in the player, there is nothing to resume, or the
 * listener closed the player after last listening (`closedAt`, milliseconds).
 */
export const restoreLastEpisode = (
    listening: Pick<ListeningStore, "resumeCandidate" | "resumePosition">,
    player: Pick<PlayerStore, "active" | "restoreSession">,
    load: (source: PodcastAudioSource, startAt: number) => void,
    closedAt = 0
): boolean => {
    const entry = listening.resumeCandidate;
    if (player.active || !entry || entry.updatedAt <= closedAt) return false;

    // The saved entry carries the fields a player needs, not the whole episode and podcast
    const episode = entry.episode as Episode;
    const podcast = entry.podcast as Podcast;
    player.restoreSession(episode, podcast);
    load(toAudioSource(episode, podcast), listening.resumePosition(episode.id));
    return true;
};
